<template>
  <div>
    <TwoPlus :gids="gids" :url="url" cur-class="pick_one" />
  </div>
</template>

<script>
import TwoPlus from '@/views/config/activity-auxiliary/twoPlus.vue'
export default {
  name: 'PickOne',
  components: {
    TwoPlus
  },
  data() {
    return {
      gids: [{ gid: 90001, gtype: 108 }, { gid: 90002, gtype: 108 }, { gid: 90003, gtype: 108 }, { gid: 90004, gtype: 108 }],
      url: '/config/activity-auxiliary/pickOne'
    }
  }
}
</script>

<style scoped>

</style>
